import { isBlank } from './object';

export function renderDefault(value: any) {
  return isBlank(value) ? '--' : value;
}
